// @core/api/endpoints/workflow/create_pipeline.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreatePipelineRequest,
  PipelineResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Create a new pipeline
 * Creates a new pipeline in draft status with an initial empty draft version. Add nodes and connections via SaveDraft.
 */
export async function CreatePipeline(
  data: CreatePipelineRequest,
  options?: RequestOptions
): Promise<PipelineResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/pipelines`;
  const requestOptions = options;
  return client.post<PipelineResponse>(requestPath, data, requestOptions);
}
